import { lazy, Suspense } from 'react'
import { Link } from 'react-router-dom'
import { BrandMark } from '../components/BrandMark'

const HomeFeatured = lazy(() =>
  import('../components/HomeFeatured').then((m) => ({ default: m.HomeFeatured }))
)
import { PageBanner } from '../components/PageBanner'
import { HomeJsonLd } from '../components/JsonLd'
import { useLocale } from '../i18n/LocaleContext'
import { toMetaDescription, usePageSeo } from '../seo/usePageSeo'

export function HomePage() {
  const { t, localePath } = useLocale()

  const homeDescription = toMetaDescription(t.linksPageDefaultTagline)
  usePageSeo({
    title: 'Wyrd Grove',
    description: homeDescription,
    path: '/',
  })

  return (
    <>
      <HomeJsonLd description={homeDescription} />
      <PageBanner variant="green">
        <div className="home-hero">
          <BrandMark variant="onDark" size="lg" alt="" />
          <h1 className="home-hero-title">{t.heroTitle}</h1>
          <p className="home-hero-lead">{t.linksPageDefaultTagline}</p>
          <div className="home-hero-actions">
            <Link to={localePath('/hand-drawn-originals')} className="btn btn-primary">
              {t.viewOriginalArtworks}
            </Link>
            <Link to={localePath('/prints')} className="btn btn-secondary">
              {t.viewPrints}
            </Link>
            <Link to={localePath('/miniatures')} className="btn btn-secondary">
              {t.viewMiniatures}
            </Link>
            <Link to={localePath('/files')} className="btn btn-secondary">
              {t.viewPrintableFiles}
            </Link>
          </div>
        </div>
      </PageBanner>

      <div className="content-wrap">
        <Suspense fallback={null}>
          <HomeFeatured />
        </Suspense>
      </div>
    </>
  )
}
